"use client";
import { createContext, useEffect, useState } from "react";
import { BANKER } from "@/contants";

const defaultGroup1FilterState = {
  banker: BANKER[0].value, // M88
  oddType: "instant"
};

const defaultGroup2FilterState = {
  banker: BANKER[3].value, // Crown
  oddType: "instant",
};

export const RecentLeaderContext = createContext({
  home: {
    id: "",
    name: "",
    logo: "",
  },
  away: {
    id: "",
    name: "",
    logo: "",
  },
  formStats: [],
});

const defaultMatchFilter = (matches, teamId) => {
  return matches.filter((item) => [item.homeId, item.awayId].includes(teamId));
};

const applyDefaultFilterAndCalculate = (matches, teamId) => {
  const filteredMatches = defaultMatchFilter(matches, teamId);
  return filterMatches(
    filteredMatches,
    defaultGroup1FilterState,
    defaultGroup2FilterState,
    teamId
  );
};

export function RecentLeaderProvider({
  children,
  leagueId,
  initialHome,
  initialAway,
  initialFormStats,
}) {
  const homeId = initialHome.id;
  const awayId = initialAway.id;

  const [group1, setGroup1] = useState(defaultGroup1FilterState);
  const [group2, setGroup2] = useState(defaultGroup2FilterState);
  const [homeHalftimeChecked, setHomeHalftimeChecked] = useState(false);
  const [awayHalftimeChecked, setAwayHalftimeChecked] = useState(false);

  const [homeMatches, setHomeMatches] = useState(
    applyDefaultFilterAndCalculate(initialFormStats.matches, homeId)
  );
  const [awayMatches, setAwayMatches] = useState(
    applyDefaultFilterAndCalculate(initialFormStats.matches, awayId)
  );

  useEffect(() => {
    const newHomeMatches = filterMatches(homeMatches.matches, group1, group2, homeId);
    const newAwayMatches = filterMatches(awayMatches.matches, group1, group2, awayId);

    setHomeMatches(newHomeMatches);
    setAwayMatches(newAwayMatches);
  }, [group1, group2]);

  const setMatchesByTeamId = (teamId, isHomeChecked) => {
    const matches = initialFormStats?.matches;

    if (teamId === homeId) {
      if (isHomeChecked) {
        setHomeMatches(
          filterMatches(
            matches.filter((item) => item.homeId === teamId),
            group1,
            group2,
            homeId
          )
        );
      } else {
        setHomeMatches(
          filterMatches(defaultMatchFilter(matches, teamId), group1, group2, homeId)
        );
      }
    }

    if (teamId === awayId) {
      if (isHomeChecked) {
        setAwayMatches(
          filterMatches(
            matches.filter((item) => item.homeId === teamId),
            group1,
            group2,
            awayId
          )
        );
      } else {
        setAwayMatches(
          filterMatches(defaultMatchFilter(matches, teamId), group1, group2, awayId)
        );
      }
    }
  };

  const setHalfTimeChecked = (teamId, isHalftimeChecked) => {
    if (teamId === homeId) {
      setHomeHalftimeChecked(isHalftimeChecked);
    }

    if (teamId === awayId) {
      setAwayHalftimeChecked(isHalftimeChecked);
    }
  };

  const filteMatchesByLength = (teamId, length) => {
    if (!length) {
      return;
    }

    const newHomeMatches = initialFormStats?.matches
      .filter((item) => [item.homeId, item.awayId].includes(teamId))
      .slice(0, length);

    const newAwayMatches = initialFormStats?.matches
      .filter((item) => [item.homeId, item.awayId].includes(teamId))
      .slice(0, length);

    if (teamId === homeId) {
      setHomeMatches(filterMatches(newHomeMatches, group1, group2, homeId));
    }

    if (teamId === awayId) {
      setAwayMatches(filterMatches(newAwayMatches, group1, group2, awayId));
    }
  };

  const filteMatchesByLeague = (teamId, isSameLeagueChecked) => {
    if (teamId === homeId && isSameLeagueChecked) {
      const newHomeMatches = homeMatches.matches.filter(
        (item) => item.leagueId === leagueId
      );
      setHomeMatches(filterMatches(newHomeMatches, group1, group2, homeId));
    } else {
      setHomeMatches(
        filterMatches(
          defaultMatchFilter(initialFormStats?.matches, homeId),
          group1,
          group2,
          homeId
        )
      );
    }

    if (teamId === awayId && isSameLeagueChecked) {
      const newAwayMatches = awayMatches.matches.filter(
        (item) => item.leagueId === leagueId
      );
      setAwayMatches(filterMatches(newAwayMatches, group1, group2, awayId));
    } else {
      setAwayMatches(
        filterMatches(
          defaultMatchFilter(initialFormStats?.matches, awayId),
          group1,
          group2,
          awayId
        )
      );
    }
  };

  const value = {
    home: initialHome,
    away: initialAway,
    homeMatches,
    awayMatches,
    homeTotal: defaultMatchFilter(initialFormStats.matches, homeId).length,
    awayTotal: defaultMatchFilter(initialFormStats.matches, awayId).length,
    group1,
    group2,
    homeHalftimeChecked,
    awayHalftimeChecked,
    setGroup1: (newFilter) => setGroup1(newFilter),
    setGroup2: (newFilter) => setGroup2(newFilter),
    toogleHomeCheck: (teamId, isHomeChecked) =>
      setMatchesByTeamId(teamId, isHomeChecked),
    setHalfTimeChecked: (teamId, isHalftimeChecked) => {
      setHalfTimeChecked(teamId, isHalftimeChecked);
    },
    filteMatchesByLength,
    filteMatchesByLeague,
  };

  return (
    <RecentLeaderContext.Provider value={value}>
      {children}
    </RecentLeaderContext.Provider>
  );
}

const filterMatches = (matches, group1, group2, teamId) => {
  const filtedMatches = matches.map((match) => {
    const {
      handicapOdds,
      handicapHalfOdds,
      europeOdds,
      overUnderOdds,
      overUnderHalfOdds,

    } = match;
    const { banker, oddType } = group1;
    const { banker: banker2, oddType: oddType2 } = group2;

    return {
      ...match,
      filterEuropeOdds: filterByBankerAndOddType(europeOdds, banker, oddType), // KEO CHAU AU
      filterHandicapOdds: filterByBankerAndOddType(
        handicapOdds,
        banker2,
        oddType2
      ), // KEO CHAU A
      filterHandicapHalfOdds: filterByBankerAndOddType(
        handicapHalfOdds,
        banker2,
        oddType2
      ), // KEO CHAU A HIEP 1
      filterOverUnderOdds: filterByBankerAndOddType(
        overUnderOdds,
        banker2,
        oddType2
      ), // KEO TAI XIU
      filterOverUnderHalfOdds: filterByBankerAndOddType(
        overUnderHalfOdds,
        banker2,
        oddType2
      ), // KEO TAI XIU HIEP 1

      handiCapResult: getHandiCapResult(match, banker2 , oddType2, false),
      handiCapHalfResult: getHandiCapResult(match, banker2 , oddType2, true),

      overUnderResult: getOverUnderResult(match, banker2 , oddType2, false),
      overUnderHalfResult: getOverUnderResult(match, banker2 , oddType2, true),
    };
  });

  return {
    matches: filtedMatches,
    total: filtedMatches.length,
    winLossRate: calculateWinLossRate(filtedMatches, false, teamId),
    halfTimeWinLossRate: calculateWinLossRate(filtedMatches, true, teamId),

    handicapRate: calculateHandicapRate(filtedMatches, false),
    halfTimeHandicapRate: calculateHandicapRate(filtedMatches, true),

    overUnderRate: calculateOverUnderRate(filtedMatches, false),
    halfTimeOverUnderRate: calculateOverUnderRate(filtedMatches, true),
  };
};

const calculateWinLossRate = (homeMatches, homeHalftimeChecked, teamId) => {
  let win = 0;
  let draw = 0;
  let loss = 0;
  let total = 0;

  let totalGoal = 0;
  let totalGoalConceded = 0;

  homeMatches.forEach((item) => {
    const { europeResult, europeHalfResult, homeScore, awayScore, homeHalfScore, awayHalfScore, homeId, awayId } = item;
    const result = homeHalftimeChecked ? europeHalfResult : europeResult;

    const homeScoreNumber = homeHalftimeChecked ? Number(homeHalfScore) : Number(homeScore);
    const awayScoreNumber = homeHalftimeChecked ? Number(awayHalfScore) : Number(awayScore);

    total++;

    if (result === 1) {
      win++;
    } else if (result === 0) {
      draw++;
    } else if (result === -1) {
      loss++;
    }

    if(teamId === homeId) {
      totalGoal += homeScoreNumber;
      totalGoalConceded += awayScoreNumber;
    }
    
    if(teamId === awayId) {
      totalGoal += awayScoreNumber;
      totalGoalConceded += homeScoreNumber;
    }
  });

  return {
    win,
    winRate: Math.round((win / total) * 100),
    draw,
    drawRate: Math.round((draw / total) * 100),
    loss,
    lossRate: Math.round((loss / total) * 100),

    totalGoalRatio: (totalGoal / total).toFixed(2),
    totalGoalConcededRatio: (totalGoalConceded / total).toFixed(2),
  };
};

const filterByBankerAndOddType = (oddList, companyId, oddType) => {
  if (!Array.isArray(oddList) || oddList.length === 0) {
    return {};
  }

  const filter = oddList.filter((item) => item.companyId === companyId);
  if (filter.length === 0) {
    return {};
  }

  const odd = filter[0];
  const result = {};
  
  const keys = Object.keys(odd);

  keys.forEach((key) => {
    if (oddType === "initial" && key.startsWith("initial")) {
      const newKey =
        key.replace("initial", "")[0].toLowerCase() +
        key.replace("initial", "").slice(1);
      result[newKey] = odd[key];
    } else if (oddType === "instant" && key.startsWith("instant")) {
      const newKey =
        key.replace("instant", "")[0].toLowerCase() +
        key.replace("instant", "").slice(1);
      result[newKey] = odd[key];
    }
  });

  return result;
};

const getHandiCapResult = (match, banker, oddType, isHalfTime) => {
  const {
    instantHandiCapResults,
    initialHandicapResults,
    instantHalfHandicapResults,
    initialHalfHandicapResults
  } = match;

  let result = null;

  if(oddType === "instant") {
    result = isHalfTime ? instantHalfHandicapResults : instantHandiCapResults;
  }

  if(oddType === "initial") {
    result = isHalfTime ? initialHalfHandicapResults : initialHandicapResults;
  }

  if(!Array.isArray(result) || result.length === 0) {
    return '-';
  }

  return result.find((item) => item.companyId === banker)?.result || '-';
}

const getOverUnderResult = (match, banker, oddType, isHalfTime) => {
  const {
    instantOverUnderResults,
    initialOverUnderResults,
    instantHalfOverUnderResults,
    initialHalfOverUnderResults,  
  } = match;

  let result = null;

  if(oddType === "instant") {
    result = isHalfTime ? instantHalfOverUnderResults : instantOverUnderResults;
  }

  if(oddType === "initial") {
    result = isHalfTime ? initialHalfOverUnderResults : initialOverUnderResults;
  }

  return result.find((item) => item.companyId === banker)?.result || '-'; 
}

const calculateHandicapRate = (matches, isHalfTime) => {
  const results = matches.map((item) => {
    const { handiCapResult, handiCapHalfResult } = item;
    return isHalfTime ? handiCapHalfResult : handiCapResult;
  })

  const filterResults = results.filter((item) => item !== '-');
  const total = filterResults.length || 1;

  return {
    winRate: (filterResults.filter((item) => item === 1).length / total * 100).toFixed(0),
    drawRate: (filterResults.filter((item) => item === 0).length / total * 100).toFixed(0),
    lossRate: (filterResults.filter((item) => item === -1).length / total * 100).toFixed(0),
  }
}

const calculateOverUnderRate = (matches, isHalfTime) => {
  const results = matches.map((item) => {
    const { overUnderResult, overUnderHalfResult } = item;
    return isHalfTime ? overUnderHalfResult : overUnderResult;
  })

  const filterResults = results.filter((item) => item !== '-');
  const total = filterResults.length || 1;

  return {
    winRate: (filterResults.filter((item) => item === 1).length / total * 100).toFixed(0),
    drawRate: (filterResults.filter((item) => item === 0).length / total * 100).toFixed(0),
    lossRate: (filterResults.filter((item) => item === -1).length / total * 100).toFixed(0),
  }
}